export default class DataUrlHelper {
  public static encode(data: string): string {
    const svgDataUrlPrefix = 'data:image/svg+xml,';
    if (data && data.startsWith(svgDataUrlPrefix)) {
      const svgData = data.slice(svgDataUrlPrefix.length, data.length);
      return `${svgDataUrlPrefix}${this.encodeSvg(svgData)}`;
    }
    return data;
  }

  private static encodeSvg(svgData: string): string {
    // part of the code is taken from the proposed solution from esbuild maintainer
    // https://github.com/evanw/esbuild/issues/1843#issuecomment-991907819 and
    // https://gist.github.com/jennyknuth/222825e315d45a738ed9d6e04c7a88d0
    return svgData.replace(/</g, '%3C').replace(/>/g, '%3E').replace(/ /g, '%20').replace(/"/g, "'").replace(/{/g, '%7B').replace(/}/g, '%7D');
  }
}
